<template>
  <div class="bg-gray-50">
    <div id="banner">
      <div class="" id="banner_wrap"
        style=" background-image: url('https://rms.guorent.com/dev/upload/addfile/1730078504/1730078504.png'); height:453px">

        <div class="layout banner">
          <h2 class="banner_title">

            <p class="p_center" style="color: #FFFFFF;font-size:48px;line-height:60px;">
            </p>
          </h2>

          <div class="signin is_show_flex" style="left:300px;top:100px">
          </div>
        </div>
      </div>
    </div>
    <div id="headnav">
      <div id="headnav_list" class="headnav layout" style="display:block">
        <ul class="headnav_list has_theme clearfix">
          <li class="headnav_li has_theme headnav_is_show color_1577FE" :class="{ 'active': isActive(item.path) }"
            v-for="(item, index) in navItems" :key="index">
            <!-- <a href="/h/spec/sxjtjy/" title="" target="_blank">首页</a> -->

            <router-link :to="item.path" tag="a" :title="item.title"> {{ item.title
              }}</router-link>
          </li>


        </ul>

        <div class="logo_wrap">
          <div class="logo">
          </div>
        </div>
      </div>
    </div>
    <router-view> </router-view>

  </div>
</template>


<script>
import CountTo from 'vue-count-to'
import { getDashboard } from '@/api/exam/examRecord'
import { courseList } from '@/api/exam/course'
import { wexinShare } from '@/utils/weixinSDK'
import { isWeixin } from "@/utils/utils";
const logoUrl = require("@/assets/img/logo.jpg");
import Vue from 'vue'
import Swipe from 'vant/lib/swipe';
import 'vant/lib/swipe/style';
import SwipeItem from 'vant/lib/swipe-item';
import 'vant/lib/swipe-item/style';
Vue.use(Swipe);
Vue.use(SwipeItem);
import headTitle from './component/headTitle'
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      activeIndex: 0, // 默认激活第一项
      navItems: [
        { title: "首页", path: "/networking/home" },
        { title: "技能大赛", path: "/networking/skillscompetition/0" },
        { title: "家庭教育专项证书", path: "/networking/skillslist/0" },
        { title: "心理健康专项证书", path: "/networking/skillslist/1" },
        { title: "三家教育论坛", path: "/networking/skillslist/2" },
        { title: "优秀讲师评选", path: "/networking/skillslist/3" },

      ]
    }
  },
  components: {
    CountTo,
    headTitle
  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {
    activePath() {
      return this.$route.path;
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index;
      this.$router.push(this.navItems[index].path); // 跳转路由
    },
    isActive(path) {
      // 精确匹配路由路径
      return this.activePath === path;
    },
    getDashboard() {
      getDashboard().then(resp => {
        this.dashboardInfo = resp.data;
      });
    },
    // 加载课程列表
    getCourseList() {
      courseList(this.courseQuery).then(response => {
        this.courseList = response.rows;
      }).catch(() => {
      })
    },
    handleStartCourse(course) {
      // messageWarn(this, '功能正在开发中！')
      this.$router.push({ name: 'course-details', query: { courseId: course.id } })
    },
    toPage(pageName) {
      this.$router.push({ name: pageName })
    },

  },

}
</script>
<style lang="scss" scoped>
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));



  .layout {
    width: 1200px;
    margin: 0 auto;
  }

  #banner {
    position: relative;
    width: 100%;
    min-width: 1200px;
    height: auto;

    #banner_wrap {
      background-repeat: no-repeat;
      background-size: auto auto;
      background-position: center top;
    }
  }

  #headnav {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    margin-top: -60px;

    #headnav_list {
      overflow: hidden;
      position: relative;
    }

    .layout {
      width: 1200px;
      margin: 0 auto;
    }

    .color_1577FE {
      background-color: #1577fe;
    }

    .headnav {
      background-color: #1577fe;

      .headnav_list {
        width: 100%;
        height: 60px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;



        .headnav_is_show {
          display: block;
        }

        .headnav_li {
          // display: none;
          /* flex: 1; */
          height: 60px;
          line-height: 60px;
          text-align: center;

          a {
            display: block;
            height: 100%;
            font-size: 20px;
            font-weight: 400;
            color: #fff;
          }
        }

      }

      .color_1577FE:before {
        background-color: #1577fe;
      }



      .clearfix:before,
      .clearfix:after {
        content: "";
        display: table;
      }
    }

    .color_1577FE {
      color: #1577fe;
    }



    .headnav_list .active {
      background-color: rgba(0, 0, 0, 0.2);
    }

    .color_1577FE:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  .container_wrap {
    width: 100%;
    min-width: 1200px;
    padding-bottom: 306px;
    overflow: hidden;

    .layout {
      width: 1200px;
      margin: 0 auto;
    }

    .container_swiper {
      height: 377px;
      margin-top: 40px;
      display: flex;
      justify-content: space-between;

      .swiper_list {
        width: 740px;
        height: 377px;
        overflow: hidden;
        position: relative;
        background-color: #ffffff;

        .my-swipe {
          width: 100%;
          height: 100%;
        }
      }

      #news {
        position: relative;
        width: 430px;
        height: 377px;

        .news_two {
          width: 100%;
          height: 100%;

          .layout_head {
            cursor: pointer;
            height: 40px;
            border-bottom: 1px solid #dfdfdf;
            position: relative;



            .head_p_list {
              .head_p {
                color: #333;
                margin-right: 20px;
                // position: relative;
                float: left;
                line-height: 30px;
                font-size: 24px;
                font-weight: 500;


              }

            }

            .head_a_list {
              .head_a {
                float: right;
                margin-top: 16px;
                line-height: 14px;
                font-size: 14px;
                font-weight: bold;
              }
            }

            .color_1577FE {
              color: #1577fe;

              .head_p:before {
                background: #1577fe;
              }
            }

            .active {
              position: relative;
              color: #1577fe;

              &::before {
                content: "";
                position: absolute;
                bottom: -10px;
                left: 0;
                width: 52px;
                height: 2px;

              }
            }
          }

          .color_1577FE {
            color: #1577fe;


            .head_p_list {

              .head_p:hover,
              .active {
                color: #1577fe;
              }

              .head_p::before {
                background: #1577fe;
              }

            }

          }

          .main_body {
            padding-top: 15px;
            overflow: hidden;
            position: relative;

            .list {
              .item {
                position: relative;
                width: 100%;
                padding-left: 17px;
                box-sizing: border-box;
                color: #505050;
                font-size: 18px;
                font-weight: 400;
                height: 36px;
                line-height: 36px;


                a {
                  width: 80%;
                  float: left;
                  color: #505050;
                  font-size: 18px;
                  font-weight: 400;
                  line-height: 36px;

                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-all;

                  &:hover {
                    color: #1577fe;
                  }
                }

                span {
                  float: right;
                  color: #999;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 36px;
                  display: block;
                }
              }

              .color_1577FE:before {
                background-color: #1577fe;
              }
            }

            .item::before {
              content: "";
              position: absolute;
              top: 16px;
              left: 0;
              width: 4px;
              height: 4px;

            }
          }
        }
      }
    }
  }




}
</style>
